import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ICoordinateActions, IThunkGetRelatedTeamMembers } from '../types';

const onGetRelatedTeamMembers: IThunkGetRelatedTeamMembers = thunk(
  async ({ setRelatedTeamMembers }: Actions<ICoordinateActions>, payload) => {
    const { clinicId, teamId, clientId } = payload;

    const { data } = await api.coordinate.getRelatedTeamMembers(clinicId, teamId, clientId);

    setRelatedTeamMembers(data);
  },
);

export default onGetRelatedTeamMembers;
